import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CustomMessagesService } from '../services/translation/custom-messages.service';

@Pipe({
    name: 'translate',
    pure: false
})
export class TranslateFilterPipe extends TranslatePipe implements PipeTransform {
    constructor(
        translate: TranslateService,
        ref: ChangeDetectorRef,
        private readonly customMessageService: CustomMessagesService
    ) {
        super(translate, ref);
    }

    override transform(value: any, args?: Array<any>): any {
        return this.customMessageService.translate(value);
    }
}
